// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainLayout_mainWrapper__Z3nI-","contentWrapper":"MainLayout_contentWrapper__MXi3V"};